"use client";
import { j as N } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as w } from "./tv.config-BuYIgndg.mjs";
import * as y from "react";
import { u as z } from "./useEventCallback-CjuAhyNz.mjs";
import { u as D } from "./useControlled-B2rPEZCb.mjs";
import { u as I } from "./useRenderElement-B8V3_e8R.mjs";
import { u as M } from "./ToggleGroupContext-DBIpDx7F.mjs";
import { u as S } from "./useButton-CQeWQM5o.mjs";
import { C as V } from "./CompositeItem-DhB3Tdag.mjs";
const P = /* @__PURE__ */ y.forwardRef(function(o, s) {
  const {
    className: r,
    defaultPressed: l = !1,
    disabled: i = !1,
    form: q,
    // never participates in form validation
    onPressedChange: c,
    pressed: E,
    render: R,
    type: A,
    // cannot change button type
    value: T,
    nativeButton: j = !0,
    ...h
  } = o, d = T ?? "", e = M(), u = (e == null ? void 0 : e.value) ?? [], x = e ? void 0 : l, f = (i || (e == null ? void 0 : e.disabled)) ?? !1, [a, B] = D({
    controlled: e && d ? (u == null ? void 0 : u.indexOf(d)) > -1 : E,
    default: x,
    name: "Toggle",
    state: "pressed"
  }), C = z((n, t) => {
    var v;
    (v = e == null ? void 0 : e.setGroupValue) == null || v.call(e, d, n, t), c == null || c(n, t);
  }), {
    getButtonProps: k,
    buttonRef: G
  } = S({
    disabled: f,
    native: j
  }), p = y.useMemo(() => ({
    disabled: f,
    pressed: a
  }), [f, a]), g = [G, s], b = [{
    "aria-pressed": a,
    onClick(n) {
      const t = !a;
      B(t), C(t, n.nativeEvent);
    }
  }, h, k], O = I("button", o, {
    enabled: !e,
    state: p,
    ref: g,
    props: b
  });
  return e ? /* @__PURE__ */ N.jsx(V, {
    tag: "button",
    render: R,
    className: r,
    state: p,
    refs: g,
    props: b
  }) : O;
});
process.env.NODE_ENV !== "production" && (P.displayName = "Toggle");
const _ = w({
  slots: {
    root: [
      "flex",
      "size-8",
      "items-center",
      "justify-center",
      "rounded-sm",
      "text-gray-600",
      "select-none",
      "hover:bg-gray-100",
      "focus-visible:bg-none",
      "focus-visible:outline",
      "focus-visible:outline-2",
      "focus-visible:-outline-offset-1",
      "focus-visible:outline-blue-800",
      "active:bg-gray-200",
      "data-[pressed]:bg-gray-200",
      "data-[pressed]:text-gray-900",
      "cursor-pointer"
    ]
  }
}), { root: $ } = _(), X = (m) => {
  const { children: o, className: s, render: r, ...l } = m, i = r ? s : $({
    className: typeof s == "string" ? s : ""
  });
  return /* @__PURE__ */ N.jsx(P, { ...l, render: r, className: i, children: o });
};
export {
  X as default
};
